<div class="overflowx-hidden">
  <!-- Foto del producto -->
  <div class="row">
    <div class="col-12">
      <img [src]="data.item.photo" alt="" class="img-fluid" *ngIf="hasImage(data.item)">
      <!-- Boton para cerrar el modal -->
      <div class="position-absolute mr-3 buttonClose animate__animated fadeIn" (click)="close()">
        <button class=" btn btn-icon-only rounded-circle" type="button"><span class=" btn-inner--icon" [ngStyle]="{'color': color}"><i
              class="fas fa-times mb-2"></i></span></button>
      </div>
    </div>
  </div>
  <!-- Informacion del producto -->
  <div class="row detail-container">
    <!-- Label de recomendado -->
    <div class="col-12">
      <!-- Label de recomendado -->
      <app-recommend *ngIf="data.item.home" [menu]="data.menu"></app-recommend>
    </div>
    <!-- Nombre del item -->
    <div class="ml-3 mt-2">
      <h2 class="font-weight-bold {{data.menu.fontHeader}}" [ngStyle]="{'color': color}" translate="no">
        {{ (data.item.name | firstuppercase) }}
      </h2>
    </div>
    <div class="col-12 item-description">
      <!-- Descripcion en espanol -->
      <p class="meal-desc {{data.menu.fontText}}" *ngIf="language === 'ES'" [ngStyle]="{'color': color}" [innerHTML]="descriptionParser.getParsedDescription(data.item, 'ES')">
      </p>
      <!-- Descripcion en ingles -->
      <p class="meal-desc {{data.menu.fontText}}" *ngIf="language === 'EN'" [ngStyle]="{'color': color}" [innerHTML]="descriptionParser.getParsedDescription(data.item, 'EN')">
      </p>
      <!-- Iconos sobre el porducto -->
      <app-type-product [menu]="data.menu" [item]="data.item" [color]="color"></app-type-product>
    </div>
    <!-- Precio del item -->
    <div class="col d-flex" *ngIf="data.item.price > 0">
      <h2 class="font-weight-bold {{data.menu.fontHeader}}" [ngStyle]="{'color': color}" [ngClass]="data.item.discount ? 'discount' : ''" translate="no">{{
        data.item.price | typeNumber: data.menu.units }}{{data.item.dollars? '/'+data.item.dollars+'usd': ''}}
      </h2>
      <h2 class="font-weight-bold {{data.menu.fontHeader}}" [ngStyle]="{'color': color}" *ngIf="data.item.discount">
        {{(+data.item.price - (+data.item.price * (+data.item.discount/100))) | typeNumber: data.menu.units }}
      </h2>

    </div>
  </div>
</div>